interface IInputTcComponentStandardInformation {
    inputTcComponentStandardInformationOrder: string;
    inputTcComponentStandardLabelGrade: string;
    inputTcComponentCertifiedWeight: number;
    inputTcComponentCertifiedWeightUsed: number;
  }
  
  interface IInputComponentRawMaterialInformation {
    inputComponentRawMaterialInformationOrder: string;
    inputTcComponentRawMaterialPercentage: number;
    inputTcComponentRawMaterialCode: string;
  }
  
  interface IInputTcComponentInformation {
    inputTcComponentInformationOrder: string;
    inputTcProductNo: string;
    inputTcProductComponentNo: string;
    inputTcComponentDetail: string;
    inputTcComponentInfoTrimsExcluded: string;
    inputTcComponentInfoAssociatedTc: string;
    inputTcComponentInfoFiberLength: string;
    inputTcComponentInfoYarnCount: number;
    inputTcComponentInfoFabricWeightAndConstruct: string;
    inputTcComponentInfoFabricWeightOfFinishedProduct: number;
    inputTcComponentNetShippingWeight: number;
    inputTcComponentSupplementaryWeight: number;
    inputTcComponentInfoAdditional: string;
    inputTcComponentStandardInformation: IInputTcComponentStandardInformation[];
    inputComponentRawMaterialInformation: IInputComponentRawMaterialInformation[];
  }
  
  interface ITcData {
    etcId: string;
    inputTcComponentInformation: IInputTcComponentInformation[];
  }

export const mapPayload = (jsonData: any[], etcId:any) => {
    return {
        etcId: etcId,
        inputTcComponentInformation: jsonData.map((component) => ({
            inputTcComponentInformationOrder: "string", // Default placeholder
            inputTcProductNo: "string",                // Default placeholder
            inputTcProductComponentNo: component.inputTcProductComponentNo || "",
            inputTcComponentDetail: component.inputTcComponentDetail || "",
            inputTcComponentInfoTrimsExcluded: component.inputTcComponentInfoTrimsExcluded || "",
            inputTcComponentInfoAssociatedTc: component.inputTcComponentInfoAssociatedTc || "",
            inputTcComponentInfoFiberLength: component.inputTcComponentInfoFiberLength || "",
            inputTcComponentInfoYarnCount: component.inputTcComponentInfoYarnCount,
            inputTcComponentInfoFabricWeightAndConstruct: component.inputTcComponentInfoFabricWeightAndConstruct || "",
            inputTcComponentInfoFabricWeightOfFinishedProduct: component.inputTcComponentInfoFabricWeightOfFinishedProduct,
            inputTcComponentNetShippingWeight: parseFloat(component.inputTcComponentNetShippingWeight) || 0,
            inputTcComponentSupplementaryWeight: parseFloat(component.inputTcComponentSupplementaryWeight) || 0,
            inputTcComponentInfoAdditional: component.inputTcComponentInfoAdditional || "",
            inputTcComponentStandardInformation: (component.inputTcComponentStandardInformation || []).map((standardInfo:any) => ({
                inputTcComponentStandardInformationOrder: standardInfo.inputTcComponentStandardInformationOrder || "",
                inputTcComponentStandardLabelGrade: standardInfo.inputTcComponentStandardLabelGrade || "",
                inputTcComponentCertifiedWeight: parseFloat(standardInfo.inputTcComponentCertifiedWeight) || 0,
                inputTcComponentCertifiedWeightUsed: parseFloat(standardInfo.inputTcComponentCertifiedWeightUsed) || 0,
                additionalProp1: {}
            })),
            inputComponentRawMaterialInformation: (component.inputComponentRawMaterialInformation || []).map((rawMaterialInfo:any) => ({
                inputComponentRawMaterialInformationOrder: rawMaterialInfo.inputComponentRawMaterialInformationOrder || "",
                inputTcComponentRawMaterialPercentage: parseInt(rawMaterialInfo.inputTcComponentRawMaterialPercentage),
                inputTcComponentRawMaterialCode: rawMaterialInfo.inputTcComponentRawMaterialCode || "",
                additionalProp1: {}
            })),
            additionalProp1: {}
        })),
        additionalProp1: {}
    };
};


export const reverseMapPayload = (payload: any) => {
    const { etcId, inputTcComponentInformation } = payload;

    const dataArray = inputTcComponentInformation.map((component: any) => ({
        inputTcProductComponentNo: component.inputTcProductComponentNo || "",
        inputTcComponentDetail: component.inputTcComponentDetail || "",
        inputTcComponentInfoTrimsExcluded: component.inputTcComponentInfoTrimsExcluded || "",
        inputTcComponentInfoAssociatedTc: component.inputTcComponentInfoAssociatedTc || "",
        inputTcComponentInfoFiberLength: component.inputTcComponentInfoFiberLength || "",
        inputTcComponentInfoYarnCount: component.inputTcComponentInfoYarnCount || 1,
        inputTcComponentInfoFabricWeightAndConstruct:
            component.inputTcComponentInfoFabricWeightAndConstruct || "",
        inputTcComponentInfoFabricWeightOfFinishedProduct:
            component.inputTcComponentInfoFabricWeightOfFinishedProduct || 10,
        inputTcComponentNetShippingWeight: component.inputTcComponentNetShippingWeight || 1,
        inputTcComponentSupplementaryWeight: component.inputTcComponentSupplementaryWeight || 1,
        inputTcComponentInfoAdditional: component.inputTcComponentInfoAdditional || "",
        "product-component-standard-info": component.inputTcComponentStandardInformation.map(
            (info: any) => ({
                inputTcComponentStandardInformationOrder:
                    info.inputTcComponentStandardInformationOrder || "",
                inputTcComponentStandardLabelGrade: info.inputTcComponentStandardLabelGrade || "",
                inputTcComponentCertifiedWeight: info.inputTcComponentCertifiedWeight || 1,
                inputTcComponentCertifiedWeightUsed: info.inputTcComponentCertifiedWeightUsed || 2,
            })
        ),
        "raw-materials-info": component.inputComponentRawMaterialInformation.map((raw: any) => ({
            inputComponentRawMaterialInformationOrder:
                raw.inputComponentRawMaterialInformationOrder || "",
            inputTcComponentRawMaterialPercentage:
                raw.inputTcComponentRawMaterialPercentage || 1,
            inputTcComponentRawMaterialCode: raw.inputTcComponentRawMaterialCode || "",
        })),
    }));

    return { etcId, dataArray };
};
